import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { jobTypeEnum } from '@modules/jobs/_jobsEnums';

export default [
  {
    label: 'Jméno',
    field: 'name',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Aktivní',
    field: 'active',
    type: ColumnType.BOOLEAN,
    width: 200
  },
  {
    label: 'Vytvořeno',
    field: 'created',
    type: ColumnType.DATETIME,
    width: 200
  },
  {
    label: 'Typ',
    field: 'scriptType',
    type: ColumnType.ENUM,
    enum: jobTypeEnum,
    width: 200
  }
];

export const jobRunColumns = [
  {
    label: 'Výsledek',
    field: 'result',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Úspěch',
    align: 'left',
    field: 'success',
    type: ColumnType.BOOLEAN,
    width: 100
  },
  {
    label: 'Vytvořeno',
    align: 'left',
    field: 'created',
    type: ColumnType.DATE,
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/jobs/_jobsColumns.ts